import { render, staticRenderFns } from "./AppExcelLogo.vue?vue&type=template&id=1548b2ea&scoped=true&"
import script from "./AppExcelLogo.vue?vue&type=script&lang=js&"
export * from "./AppExcelLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1548b2ea",
  null
  
)

export default component.exports